import React from 'react'
import { useStaticQuery, graphql } from 'gatsby';
import { useLocale } from '../../hooks';
export const useSitemap = () => {
    const locale = useLocale()
    const data = useStaticQuery(graphql`
    query {
        allContentfulPageProduct {
            edges{
                node {
                    node_locale
                    title
                    slug
                }    
            }
        }
        allContentfulPageArticle {
            edges{
                node {
                    node_locale
                    title: thumbnailTitle
                    slug
                }                        
            }
        }
        allContentfulPageProductsCategory(filter: {pageType: {eq: "Products"}}) {
            edges{
                node {
                    node_locale
                    title: seoTitle
                    slug
                }                        
            }
        }
    }
    `
    )
    for (const key in data) {
        data[key] = data[key]?.edges?.filter((edge) => edge.node.node_locale === locale)
    }
    return data
}